import { AllowPolicy } from '@wix/ambassador-social-groups-v2-group/types';

const memberPermissionsWeight: Record<AllowPolicy, number> = {
  [AllowPolicy.UNKNOWN]: -1,
  [AllowPolicy.ALL_MEMBERS]: 0,
  [AllowPolicy.OWNER_AND_ADMINS]: 1,
  [AllowPolicy.OWNER]: 2,
};

export function isMoreRestrictive(
  next: AllowPolicy,
  current?: AllowPolicy,
): boolean {
  return (
    memberPermissionsWeight[next] >
    memberPermissionsWeight[current ?? AllowPolicy.UNKNOWN]
  );
}

export function getDisabledPolicies(minimum?: AllowPolicy) {
  return [AllowPolicy.ALL_MEMBERS, AllowPolicy.OWNER_AND_ADMINS].filter(
    (policy) => isMoreRestrictive(minimum ?? AllowPolicy.UNKNOWN, policy),
  );
}

export function getInviteDisabledPolicies(
  current?: AllowPolicy,
  isSiteAdmin?: boolean,
) {
  if (isSiteAdmin) {
    return [];
  }

  if (current === AllowPolicy.OWNER) {
    return [
      AllowPolicy.ALL_MEMBERS,
      AllowPolicy.OWNER_AND_ADMINS,
      AllowPolicy.OWNER,
    ];
  }

  return [AllowPolicy.OWNER];
}
